function createSearchParams(params: Record<string, string | null>) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null) {
      searchParams.append(key, value);
    }
  }
  return searchParams.toString();
}

export { createSearchParams };